import React from 'react';

import { screens } from '../config/uiFactory.config';
import SubscriptionManagementLandingPage from '../subscriptionManagement/landingPage/SubscriptionManagementLandingPage';
import DataTransactionReport from '../transaction-report/DataTransactionReport';
import RemoveLocations from '../subscriptionManagement/menuOptions/removeLocations/RemoveLocations';
import Stepper from '../stepper/Stepper';
import EditPrivacyProtection from '../subscriptionManagement/menuOptions/privacyProtection/EditPrivacyProtection';
import EditDMSAccounts from '../subscriptionManagement/menuOptions/manageDMSAccounts/EditDMSAccounts';
import EditApiFields from '../stepper/stepperBody/stepperBodyComponents/EditApiFields';
import {EditDMSAccountsV2} from '../subscriptionManagement/menuOptions/manageDMSAccounts/EditDMSAccountsV2';
import NewApiIntegrationsPage from '../subscriptionManagement/menuOptions/manageIntegrations/index';
import StepperContainer from '../stepper/StepperContainer';
import ManageBulkConnections from '../subscriptionManagement/menuOptions/manageIntegrations/manageBulkConnections/index'
import AppConsents from '../subscriptionManagement/menuOptions/appConsents/AppConsents';
import PurchaseReport from '../PurchaseReport/PurchaseReport';
import DealerIntegrationReport from '../integration-report/DealerIntegrationReport';
import EditVerticalScopingContainer from '../subscriptionManagement/menuOptions/manageVerticalScoping/EditVerticalScopingContainer'
import ManageIntegrationsV2 from '../subscriptionManagement/menuOptions/manageIntegrations/v2/LandingPage';
import APIDirectory from '../APIBuyer/DealerAPIDirectory/APIDirectory';
import MainMenu from '../Menu/MainMenu';
import OrderDetails from '../APIBuyer/MyAPIs/OrderDetails';
import OrderAPIContainer from '../APIBuyer/OrderAPI/OrderAPIContainer';
import { AddLocations } from '../APIBuyer/MyAPIs/DAABSubscriptions/AddLocations';
import ViewLocations from '../APIBuyer/MyAPIs/Tabs/APIs/ViewLocations/ViewLocations'
import { RemoveSubscriptionLocations } from '../APIBuyer/MyAPIs/DAABSubscriptions/RemoveSubscriptionLocations';
import { BundleLocationsTable } from '../APIBuyer/MyAPIs/DAABSubscriptions/BundleAddLocations';
import { EditApiSubscriptionSettings } from '../subscriptionManagement/menuOptions/manageApiSubscriptionSettings/EditApiSubscriptionSettings';

export const ScreenToLoad = {
    [screens.SUBSCRIPTION_MANAGEMENT]: ({ solutionData, additionalData = {} }) => {
        return <SubscriptionManagementLandingPage
            solutionData={solutionData}
            activateUnsubscription={additionalData.activateUnsubscription}
            subscriptionData={additionalData.subscriptionData}
            isBulkSubscribed={additionalData.isBulkSubscribed}
            // selectedPlanId={selectedPlanId}
        />;
    },
    [screens.TRANSACTION_REPORT]: () => {
        return <DataTransactionReport />;
    },
    [screens.INTEGRATION_REPORT]: () => {
        return <DealerIntegrationReport />;
    },
    [screens.REMOVE_LOCATIONS]: ({ solutionData, additionalData }) => {
        return <RemoveLocations
            solutionData={solutionData}
            subscriptionData={additionalData.subscriptionData}
            isBulkSubscribed={additionalData.isBulkSubscribed}
        />;
    },
    [screens.STEPPER]: ({ solutionData, additionalData = {} }) => {
        return <Stepper
            solutionData={solutionData}
            bodyConfig={additionalData.stepperConfig}
            defaultStep={additionalData.defaultStep}
            navigatedFromSubscriptionManagement={additionalData.navigatedFromSubscriptionManagement}
            source={additionalData.source}
            // selectedPlanId={additionalData.selectedPlanId}
        />;
    },
    [screens.MANAGE_PRIVACY_PROTECTION]: ({ solutionData, additionalData }) => {
        return <EditPrivacyProtection
            solutionData={solutionData}
            additionalData={additionalData}
        />;
    },
    [screens.EDIT_API_FIELDS]: ({ solutionData, additionalData }) => {
        return <EditApiFields
            solutionData={solutionData}
            additionalData={additionalData}
        />;
    },
    [screens.MANAGE_DMS_ACCOUNTS]: ({ solutionData, additionalData }) => {
        return <EditDMSAccounts
            solutionData={solutionData}
            additionalData={additionalData}
        />;
    },
    [screens.MANAGE_DMS_ACCOUNTS_V2]: ({ solutionData, additionalData }) => {
        return <EditDMSAccountsV2
            solutionData={solutionData}
            additionalData={additionalData}
        />;
    },
    [screens.MANAGE_INTEGRATION]: ({ solutionData, additionalData }) => {
        return <NewApiIntegrationsPage
            solutionData={solutionData}
            subscriptionData={additionalData.subscriptionData}
            isBulkSubscribed={additionalData.isBulkSubscribed}
            isAppNotListed={additionalData.isAppNotListed}
            // selectedPlanId={additionalData.selectedPlanId}
        />;
    },
    [screens.STEPPER_CONTAINER]: ({ solutionData, additionalData = {} }) => {
        return <StepperContainer
            solutionData={solutionData}
            defaultStep={additionalData.defaultStep}
            navigatedFromSubscriptionManagement={additionalData.navigatedFromSubscriptionManagement}
            source={additionalData.source}
            // selectedPlanId={additionalData.selectedPlanId}
        />;
    },
    [screens.Manage_BulkConnections]: ({ solutionData, additionalData = {} }) => {
        return <ManageBulkConnections
            solutionData={solutionData}
            additionalData={additionalData}
        />;
    },
    [screens.MANAGE_INTEGRATIONS_V2]: ({ solutionData, additionalData = {} }) => {
        return <ManageIntegrationsV2
            solutionData={solutionData}
            additionalData={additionalData}
        />;
    },
    [screens.DEALER_PURCHASE_REPORT]: () => {
        return <PurchaseReport />;
    },
    [screens.APP_CONSENTS]: ({ solutionData, additionalData = {} }) => {
        return <AppConsents
            solutionData={solutionData}
            additionalData={additionalData}
        />;
    },
    [screens.MANAGE_VERTICAL_SCOPING]: ({ solutionData, additionalData = {} }) => {
      return (
        <EditVerticalScopingContainer
          solutionData={solutionData}
          additionalData={additionalData}
        />
      );
    },
    [screens.MANAGE_API_SUBSCRIPTION_SETTINGS]: ({solutionData, additionalData = {}}) => {
      return <EditApiSubscriptionSettings
          solutionData={solutionData}
          additionalData={additionalData}
      />;
    },
    [screens.API_DIRECTORY]: () => {
      return <APIDirectory/>
    },
    [screens.DASHBOARD]: () => {
        return <MainMenu />
    },
    [screens.MY_APIS]: () => {
        return <OrderDetails/>
    },
    [screens.CHECKOUT]: () => {
        return <OrderAPIContainer/>
    },
    [screens.DAAB_ADD_LOCATIONS]: ({solutionData, additionalData}) => {
        return <AddLocations solutionData={solutionData} {...additionalData}/>
    },
    [screens.DAAB_BUNDLE_ADD_LOCATIONS]: ({solutionData, additionalData}) => {
        return <BundleLocationsTable solutionData={solutionData} {...additionalData}/>
    },
    [screens.DAAB_REMOVE_LOCATIONS]: ({solutionData, additionalData}) => {
        return <RemoveSubscriptionLocations solutionData={solutionData} {...additionalData}/>
    },
    [screens.VIEW_LOCATIONS]: ({additionalData}) => {
        return (
        <ViewLocations 
            apiData={additionalData}
        />
    )
    }
}
